import PropTypes from 'prop-types';
import { DeleteOutlined, Edit, Email } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';

import { ListItemWrapper } from 'components/ui';

import * as Styled from './ListItem.styles';

export const ListItem = ({ item, onEdit, onDelete }) => {
  return (
    <ListItemWrapper>
      <Styled.Info>
        <Email className="icon" />
        <div className="info">
          <div className="name">{item.name}</div>
          <div className="email">{item.email}</div>
        </div>
      </Styled.Info>
      <Styled.Actions>
        <IconButton onClick={onEdit}>
          <Edit />
        </IconButton>
        <IconButton color="error" onClick={onDelete}>
          <DeleteOutlined />
        </IconButton>
      </Styled.Actions>
    </ListItemWrapper>
  );
};

ListItem.propTypes = {
  item: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};
